<template>
  <v-card>
    <v-card-text>
     <component contenteditable :is="createComp(value)"/>
   </v-card-text>
  </v-card>   
 </template>

<script>
  import formats from '../../api/formats.js'
  export default {
    name: 'v-flex-field',
    props: {
      label: null,
      value: null
    },
    data: function () {
      return {
      }
    },
    created () {
    },
    computed: {
    },
    methods: {
      createComp (template) {
        // let html = `<span>${template}</span>`
        return formats.createComp(`<span>${template}</span>`)
      }
    }
  }
</script>
<style type="text/css">
  [contenteditable]:focus {
    outline: 0px solid transparent;
  }
</style>



// WEBPACK FOOTER //
// FlexField.vue?47db97b4